export default Object.freeze({
  raw_request_cnt: {
    name: '请求数'
  },
  delivered_request_cnt: {
    name: '返回数'
  },
  charged_impression_cnt: {
    name: '曝光数'
  },
  cost: {
    name: '预计收入'
  },
  // impressions: {
  //   name: '曝光'
  // },
  // clicks: {
  //   name: '点击'
  // },
  // trueviews: {
  //   name: '有效播放'
  // },
  // click_rate: {
  //   name: '点击率(%)'
  // },
  // revenue: {
  //   name: '总消耗(元)'
  // },
  // avg_cpm: {
  //   name: '平均CPM(元)'
  // },
  // avg_cpc: {
  //   name: '平均CPC(元)'
  // },
  // avg_cpv: {
  //   name: '平均CPV(元)'
  // },
  // conversion_count: {
  //   name: '转化数'
  // },
  // conversion_cost: {
  //   name: '转化成本'
  // },
  // revenue_percent: {
  //   name: '总消耗占比(%)'
  // },

  // downloaded: {
  //   name: '下载完成'
  // },
  // downloading: {
  //   name: '下载开始'
  // },
  // installed: {
  //   name: '安装完成'
  // },
  // deep_conversion_cnt: {
  //   name: '深度转化数'
  // },
  // deep_conversion_cost: {
  //   name: '深度转化成本'
  // },
  // start_play_cnt: {
  //   name: '开始播放数'
  // },
  // quarter_play_cnt: {
  //   name: '25%进度播放数(元)'
  // },
  // middle_play_cnt: {
  //   name: '50%进度播放数'
  // },
  // three_quarter_play_cnt: {
  //   name: '75%进度播放数'
  // },
  // completed_play_cnt: {
  //   name: '100%进度播放数'
  // },
});